import React from 'react'
import PropTypes from 'prop-types'

const SubscriptionTitle = ({ title, htmlTitle, className }) => {
  return (
    <span className={className}>
      {htmlTitle
        ? <div dangerouslySetInnerHTML={{ __html: htmlTitle }} />
        : <div>{title}</div>
      }
    </span>
  )
}

SubscriptionTitle.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  hasSpacer: PropTypes.bool,
}

SubscriptionTitle.defaultProps = {
  title: '',
  className: '',
}

export default SubscriptionTitle
